import { render, staticRenderFns } from "./TreatmentSection.vue?vue&type=template&id=213c1eff&scoped=true"
import script from "./TreatmentSection.vue?vue&type=script&lang=js"
export * from "./TreatmentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c1eff",
  null
  
)

export default component.exports